import Navbar from '@/pages/home/components/Navbar';
import HeroSection from '@/pages/home/components/HeroSection';
import DownloadEntries from '@/pages/home/components/DownloadEntries';
import VersionPanel from '@/pages/home/components/VersionPanel';
import InstallSteps from '@/pages/home/components/InstallSteps';
import TopicWall from '@/pages/home/components/TopicWall';
import HotRanking from '@/pages/home/components/HotRanking';
import GuideGrid from '@/pages/home/components/GuideGrid';
import FaqSection from '@/pages/home/components/FaqSection';
import CtaBand from '@/pages/home/components/CtaBand';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <DownloadEntries />
        <VersionPanel />
        <InstallSteps />
        <TopicWall />
        <HotRanking />
        <GuideGrid />
        <FaqSection />
        <CtaBand />
      </main>
      <Footer />
    </div>
  );
}